<template>
    <div class="channels-container">
        <div v-for="(channel, index) in audio.channels" :key="index">
            <mono-channel-level
                :channel="channel"
            ></mono-channel-level>
        </div>
    </div>
</template>

<script>
    import MonoChannelLevel from './mono-channel-level.vue';
    export default {
        name:'MultipleChannel',
        components: {
            MonoChannelLevel,
        },
        props: {
            audio: {
                type: Object,
                required: true,
            }
        }
    };
</script>

<style>
    .channels-container{
        display: flex;
        margin-right: 0.5rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/Preview/PreviewAudio/multiple-channel.vue